module.exports = __webpack_public_path__ + "img/image1.0d319672.jpg";